import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Link from "@mui/material/Link";
import Container from "../../../common/Container";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Avatar } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import HomeIcon from "@mui/icons-material/Home";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { blue } from "@mui/material/colors";
import press from "../../../assets/banner/press_1.jpeg";
import press2 from "../../../assets/2022_aca/img13.jpg";
import award1 from "../../../assets/banner/banner1.jpg";
import award2 from "../../../assets/banner/2026_banner_2.png";
import rollup from "../../../assets/banner/2026_banner_4.png";

const latest = [
  {
    title: "BudgIT Opens Nominations for 2023 Active Citizens Award",
    date: "July 17, 2023",

    img: award1,
    links: "/budgit-opens-nominations-for-2023-active-citizens-award",
  },
  {
    img: press2,
    title: " Tunde Onakoya bags BudgIT’s Active Citizens Award",
    date: "September 18, 2022",
    links: "/tunde-onakoya-bags-budgit-active-citizens-award",
  },
  {
    img: press,
    title: " Press Statement: Maiden Edition of the Active Citizens Awards",
    date: "July 15, 2022",
    links:
      "/budgit-set-to-host-the-maiden-edition-of-the-active-citizens-awards",
  },
];

const FourthRelease = () => {
  const theme = useTheme();

  const handleShare = (e) => {
    e.preventDefault();

    const ahref = window.location.href;
    const encodedAhref = encodeURIComponent(ahref);
    var link;

    switch (e.currentTarget.id) {
      case "facebook":
        link = `https://www.facebook.com/sharer/sharer.php?u=${ahref}`;
        open(link);
        break;

      case "twitter":
        link = `https://twitter.com/intent/tweet?url=${encodedAhref}`;
        open(link);
        break;

      case "linkedin":
        link = `https://www.linkedin.com/sharing/share-offsite/?url=${ahref}`;
        open(link);
        break;

      default:
        break;
    }
  };

  const open = (socialLink) => {
    window.open(socialLink, "_blank");
  };

  return (
    <Box>
      <Helmet>
        <title> Blog | BudgIT Active Citizens Awards</title>
      </Helmet>
      <AppBar
        position={"fixed"}
        sx={{
          backgroundColor: theme.palette.background.paper,
        }}
        elevation={0}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 }}>
          <Header />
        </Container>
      </AppBar>
      <Container>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"flex-start"}
          flexWrap={"wrap"}
        >
          <Box
            width={{ xs: "100%", sm: "65%" }}
            paddingTop={{ xs: "35%", sm: "10%" }}
            marginLeft={{ xs: "0%", sm: "0%" }}
          >
            <Box display={"flex"} alignItems={"center"} marginBottom={"5%"}>
              <img src={award2} alt="logo" width="95%" />
            </Box>
            <Typography
              variant="h4"
              color={"#049593"}
              fontWeight={700}
              paddingBottom={{ xs: "10%", sm: "5%" }}
              textAlign={"center"}
            >
              Call for Nominations Opens for the Active Citizens Awards 2026
            </Typography>
            <Box
              paddingBottom={{ xs: "10%", sm: "5%" }}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              flexWrap={"wrap"}
              width={{ xs: "90%", sm: "55%" }}
              marginLeft={0}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                width={{ xs: "45%", sm: "35%" }}
                paddingBottom={{ xs: "5%", sm: "0%" }}
              >
                <CalendarTodayIcon sx={{ color: "#049593" }} />
                <Typography variant="body1" color={"#4f4f4f"}>
                  May 14, 2026
                </Typography>
              </Box>
              <Box width={{ xs: "65%", sm: "40%" }}>
                <Breadcrumbs
                  aria-label="breadcrumb"
                  separator={<NavigateNextIcon fontSize="small" />}
                >
                  <Link
                    underline="hover"
                    sx={{ display: "flex", alignItems: "center" }}
                    color="#049593"
                    href="/"
                  >
                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                    Home
                  </Link>
                  <Link
                    underline="hover"
                    sx={{ display: "flex", alignItems: "center" }}
                    color="#049593"
                    href="/Blog"
                  >
                    <WhatshotIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                    Blog
                  </Link>
                </Breadcrumbs>
              </Box>
            </Box>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              BudgIT, Nigeria's leading civic-tech organization championing
              accountability, transparency, and effective service delivery, is
              preparing to host the third annual Active Citizens Awards. The
              event, which is themed{" "}
              <Typography
                component={"span"}
                fontWeight={700}
                fontStyle={"italic"}
              >
                'Celebrating Voices, Inspiring Actions'
              </Typography>
              , will take place on Friday, July 24, 2026, at the Civic Centre,
              Victoria Island, Lagos.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              The Active Citizens Awards recognizes changemakers who are using
              advocacy, technology, community organizing, creativity, research,
              and public service to drive positive social impact and strengthen
              democratic values. The awards seek to spotlight citizens and
              groups whose work continues to inspire participation,
              accountability, inclusion, and collective action within society.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Speaking on the award BudgIT’s Country Director, Vahyala Kwaga,
              said: “The Active Citizens Awards is about recognizing the
              everyday people and organizations who continue to show courage,
              leadership, and commitment to building stronger communities and a
              more accountable society. Across Nigeria, we are witnessing young
              people, civic actors, creatives, and innovators shaping the future
              of democracy and citizen participation, often against difficult
              odds. This award is an opportunity to celebrate their impact and
              amplify their work.”
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Also speaking, Joseph Amenaghawon, Chair of the Selection
              Committee, added that the awards process will prioritize
              credibility, impact, innovation, and community relevance when
              assessing nominees. “We are committed to a transparent and
              rigorous selection process that highlights individuals and
              organizations creating meaningful change in their communities.
              This award is designed not only to celebrate achievements but also
              to elevate stories of active citizenship; stories that can inspire
              broader civic participation across the continent.”
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "2%", sm: "1%" }}
              fontWeight={700}
              color={"#4f4f4f"}
            >
              Nominations
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              The 2026 awards feature a total of twelve (12) categories. Seven
              of these categories are open for public nomination. For the
              remaining five categories, the winners will be selected by the
              awards committee after extensive research and thoughtful
              deliberation against specific criteria. Nominations are open to
              activists, civic leaders, community organizers, social
              entrepreneurs, artists, media practitioners, youth-led
              initiatives, nonprofit organizations, and innovators making
              measurable contributions within their communities and sectors.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "2%", sm: "1%" }}
              fontWeight={700}
              color={"#4f4f4f"}
            >
              Criteria and Eligibility for Nomination
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              When nominating an individual or organization for any open
              category, you must first confirm their eligibility for that
              specific category. The assessment of shortlisted nominees and the
              final selection of winners will be based on specific criteria:
              innovation, impact, milestones, sustainability, diversity,
              inclusion, organizational structure, and leadership quality.
              Therefore, all nominations must include links to relevant projects
              or impacts the nominee has successfully completed within the
              designated timeframe, as these links should directly support their
              alignment with the evaluation criteria. Members of the public are
              encouraged to submit nominations for deserving individuals and
              organizations through the official nomination platform.
              Self-nominations will also be accepted.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "2%", sm: "1%" }}
              fontWeight={700}
              color={"#4f4f4f"}
            >
              Shortlisting and Selection
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              A carefully chosen Panel of Judges will conduct a thorough,
              three-stage review process following the nomination period. This
              selection process will result in a final shortlist of three
              individuals who have achieved the highest grade points in each
              category. Ultimately, only one of these three nominees will be
              selected as the winner in their respective category. The
              nomination platform opens on May 14, 2026 and closes on June 14,
              2026. Shortlisted nominees and award recipients will be announced
              ahead of the official Active Citizens Awards ceremony scheduled to
              hold on July 24, 2026. To learn more about the 2026 Active Citizen
              Award, including sponsorship opportunities, please visit{" "}
              <Link
                component={"a"}
                color="#049593"
                fontWeight={700}
                variant={"body1"}
                sx={{
                  cursor: "pointer",
                }}
              >
                https://awards.civichive.org/
              </Link>{" "}
              or contact us via email at awards@budgit.org.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              For details on nomination guidelines, award categories, and
              submission procedures, visit{" "}
              <Link
                component={"a"}
                color="#049593"
                fontWeight={700}
                variant={"body1"}
                sx={{
                  cursor: "pointer",
                }}
              >
                https://awards.civichive.org/the-award
              </Link>
            </Typography>
            <Typography
              variant="body1"
              color={"#4f4f4f"}
              paddingBottom={{ xs: "5%", sm: "2%" }}
            >
              Signed
            </Typography>
            <Typography variant="body2" color={"#4f4f4f"} fontWeight={700}>
              Temidayo Musa
            </Typography>
            <Typography variant="body2" color={"#4f4f4f"} fontWeight={700}>
              Chair, 2026 ACA Planning Committee
            </Typography>
            <Box
              marginTop={"5%"}
              width={{ xs: "60%", sm: "40%" }}
              marginLeft={0}
            >
              <Typography variant="body1" fontWeight={700} color={"#049593"}>
                Share this post
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  width={{ xs: "70%", sm: "50%" }}
                  marginLeft={"0%"}
                >
                  <Avatar
                    sx={{
                      bgcolor: blue[900],
                      width: 36,
                      height: 36,
                      cursor: "pointer",
                    }}
                    id="facebook"
                    onClick={handleShare}
                  >
                    <FacebookIcon />
                  </Avatar>
                  <Avatar
                    sx={{
                      bgcolor: blue[300],
                      width: 36,
                      height: 36,
                      cursor: "pointer",
                    }}
                    id="twitter"
                    onClick={handleShare}
                  >
                    <TwitterIcon />
                  </Avatar>
                  <Avatar
                    sx={{
                      bgcolor: blue[700],
                      width: 36,
                      height: 36,
                      cursor: "pointer",
                    }}
                    id="linkedin"
                    onClick={handleShare}
                  >
                    <LinkedInIcon
                      sx={{
                        bgcolor: blue[700],
                      }}
                    />
                  </Avatar>
                </Box>
              </Typography>
            </Box>
          </Box>
          <Box
            width={{ xs: "92%", sm: "25%" }}
            marginTop={{ xs: "25%", sm: "10%" }}
          >
            <Typography variant="h5" fontWeight={700} color={"#049593"}>
              Related Posts
            </Typography>
            {latest.map((post, index) => (
              <Box
                marginTop={"10%"}
                display={"flex"}
                key={index}
                justifyContent={"space-between"}
                alignItems={"center"}
                flexWrap={{ xs: "wrap", sm: "none" }}
              >
                <Box
                  display={"flex"}
                  alignItems={"left"}
                  marginBottom={"5%"}
                  marginLeft={{ xs: "0%", sm: "0%" }}
                  width={{ xs: "65%", sm: "40%" }}
                >
                  <img src={post.img} alt="logo" width={"100%"} />
                </Box>
                <Box width={{ xs: "100%", sm: "50%" }}>
                  <Link
                    variant="body2"
                    color={"#049593"}
                    fontWeight={500}
                    paddingBottom={{ xs: "10%", sm: "5%" }}
                    textAlign={"center"}
                    href={post.links}
                    underline="hover"
                  >
                    {post.title}
                  </Link>
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    color={"#aaa"}
                    paddingTop={"2%"}
                  >
                    {post.date}
                  </Typography>
                </Box>
              </Box>
            ))}
            <Box
              component="img"
              height={{ xs: "27vh", sm: "800px" }}
              sx={{
                objectFit: "cover",
              }}
              src={rollup}
              alt={"aca2023_img"}
              display={{ xs: "none", sm: "block" }}
              marginRight={{ xs: "0%", sm: "0.5%" }}
              marginBottom={{ xs: "1%", sm: "0.5%" }}
              marginTop={{ xs: "1%", sm: "40%" }}
            />
          </Box>
        </Box>
      </Container>
      <Box bgcolor={"#049593"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default FourthRelease;
